module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARNJREFUeNq0lo0NgyAQhZE4QEdwBEdghI5gN3AEu0FHcARHcATcgG6AE1yPBluSAh4/fclLFJTP4+CwAYCRMdajF+v/CEHGK3y1oAf0xfZV8XFhBtXwq2pQ90ZAXCbqEd2VgownoEmmQn2NK6RJ2g/sU0GhfFGk0A8fNPQFAsp1QK8xELM5qKXpLIlLBchwFtGRL1UKoYCYTWyqtM3zZ5yWUKVUYlXb0QIt3UZOeFEkQJ4+iFFbEbTZZ7WvkxJRXwpxj4mYzzTn1rqUCjFTiyovmLY7eqCukjZzIdzQc85RHrKK7faSg89159ntfe5RzonTtoc2IlWcsBA2ey1L/raa9/z5JZ3IdOlvXSwiXQti9BJgAGElUHbiDG1KAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/arrow6.png
// module id = AKk5
// module chunks = 50